import { useAxesTooltip } from "@mui/x-charts";
import {
	LineHighlightElement,
	type LineHighlightElementProps,
} from "@mui/x-charts/LineChart";
import type { FC } from "react";
import { useInterpolatedPeriods } from "web_myplann/Portfolio/Components/Redesign/Detail/InterpolatedPeriodsContext";
import { findInterpolatedPeriod } from "web_myplann/Portfolio/Helpers/interpolatedPeriods";

export const InterpolatedAwareLineHighlight: FC<LineHighlightElementProps> = (
	props,
) => {
	const periods = useInterpolatedPeriods();
	const tooltip = useAxesTooltip();
	const axisValue = tooltip?.[0]?.axisValue;

	if (findInterpolatedPeriod(periods, axisValue)) {
		return null;
	}

	return <LineHighlightElement {...props} />;
};
